module.exports = __webpack_public_path__ + "static/media/work-pension.2d7c9f0d.svg";